<template>
  <error-layout :code="404" error="Страница не найдена"></error-layout>
</template>

<script>
import ErrorLayout from '../layouts/ErrorLayout.vue';

export default {
  metaInfo() {
    return {
      title: '404 – Страница не найдена',
    };
  },
  components: { ErrorLayout },
};
</script>
